import Vue from 'vue'
export default () => {
    // 针对 el-input做的限制，只能输入正整数
    Vue.directive('Int', {
        bind: function (el) {
            const input = el.getElementsByTagName('input')[0]
            input.onkeyup = function (e) {
                if (input.value.length === 1) {
                    input.value = input.value.replace(/[^1-9]/g, '')
                } else {
                    input.value = input.value.replace(/[^\d]/g, '')
                }
                trigger(input, 'input')
            }
            input.onblur = function (e) {
                if (input.value.length === 1) {
                    input.value = input.value.replace(/[^1-9]/g, '')
                } else {
                    input.value = input.value.replace(/[^\d]/g, '')
                }
                trigger(input, 'input')
            }
        }

    })
}

//函数去抖，适用于新建请求中
let timer = null;
export function debounce(method) {
    // let timer = null;
    // return function() {
        clearTimeout(timer);
        timer = setTimeout(function() {
            method();
        }, 200);
    // }
}

/*********************************
 ** Fn: trigger
 ** Intro: 参考 https://github.com/vuejs/Discussion/issues/157#issuecomment-273301588
 ** Author: zyx
 *********************************/
const trigger = (el, type) => {
    const e = document.createEvent('HTMLEvents')
    e.initEvent(type, true, true)
    el.dispatchEvent(e)
}



export function formatTimeSec(sec) {
    var tmp = Math.floor(sec / 60);
    var ss = sec % 60;
    var MM = tmp % 60;
    var hh = Math.floor(tmp / 60);
    return hh + ":" + MM + ":" +ss;
}